/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as MeRouteImport } from './routes/me'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignInVerifyRouteImport } from './routes/sign-in_.verify'
import { Route as SignInTotpRouteImport } from './routes/sign-in_.totp'
import { Route as PasswordResetRequestRouteImport } from './routes/password-reset_.request'
import { Route as EmailChangeVerifyRouteImport } from './routes/email-change.verify'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInVerifyRoute = SignInVerifyRouteImport.update({
  id: '/sign-in_/verify',
  path: '/sign-in/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInTotpRoute = SignInTotpRouteImport.update({
  id: '/sign-in_/totp',
  path: '/sign-in/totp',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRequestRoute = PasswordResetRequestRouteImport.update({
  id: '/password-reset_/request',
  path: '/password-reset/request',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailChangeVerifyRoute = EmailChangeVerifyRouteImport.update({
  id: '/email-change/verify',
  path: '/email-change/verify',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/me': typeof MeRoute
  '/password-reset': typeof PasswordResetRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/sign-in': typeof SignInRoute
  '/email-change/verify': typeof EmailChangeVerifyRoute
  '/password-reset/request': typeof PasswordResetRequestRoute
  '/sign-in/totp': typeof SignInTotpRoute
  '/sign-in/verify': typeof SignInVerifyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/me': typeof MeRoute
  '/password-reset': typeof PasswordResetRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/sign-in': typeof SignInRoute
  '/email-change/verify': typeof EmailChangeVerifyRoute
  '/password-reset/request': typeof PasswordResetRequestRoute
  '/sign-in/totp': typeof SignInTotpRoute
  '/sign-in/verify': typeof SignInVerifyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/me': typeof MeRoute
  '/password-reset': typeof PasswordResetRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/sign-in': typeof SignInRoute
  '/email-change/verify': typeof EmailChangeVerifyRoute
  '/password-reset_/request': typeof PasswordResetRequestRoute
  '/sign-in_/totp': typeof SignInTotpRoute
  '/sign-in_/verify': typeof SignInVerifyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/me'
    | '/password-reset'
    | '/profile'
    | '/security'
    | '/sign-in'
    | '/email-change/verify'
    | '/password-reset/request'
    | '/sign-in/totp'
    | '/sign-in/verify'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/me'
    | '/password-reset'
    | '/profile'
    | '/security'
    | '/sign-in'
    | '/email-change/verify'
    | '/password-reset/request'
    | '/sign-in/totp'
    | '/sign-in/verify'
  id:
    | '__root__'
    | '/'
    | '/me'
    | '/password-reset'
    | '/profile'
    | '/security'
    | '/sign-in'
    | '/email-change/verify'
    | '/password-reset_/request'
    | '/sign-in_/totp'
    | '/sign-in_/verify'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MeRoute: typeof MeRoute
  PasswordResetRoute: typeof PasswordResetRoute
  ProfileRoute: typeof ProfileRoute
  SecurityRoute: typeof SecurityRoute
  SignInRoute: typeof SignInRoute
  EmailChangeVerifyRoute: typeof EmailChangeVerifyRoute
  PasswordResetRequestRoute: typeof PasswordResetRequestRoute
  SignInTotpRoute: typeof SignInTotpRoute
  SignInVerifyRoute: typeof SignInVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in_/verify': {
      id: '/sign-in_/verify'
      path: '/sign-in/verify'
      fullPath: '/sign-in/verify'
      preLoaderRoute: typeof SignInVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in_/totp': {
      id: '/sign-in_/totp'
      path: '/sign-in/totp'
      fullPath: '/sign-in/totp'
      preLoaderRoute: typeof SignInTotpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset_/request': {
      id: '/password-reset_/request'
      path: '/password-reset/request'
      fullPath: '/password-reset/request'
      preLoaderRoute: typeof PasswordResetRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-change/verify': {
      id: '/email-change/verify'
      path: '/email-change/verify'
      fullPath: '/email-change/verify'
      preLoaderRoute: typeof EmailChangeVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MeRoute: MeRoute,
  PasswordResetRoute: PasswordResetRoute,
  ProfileRoute: ProfileRoute,
  SecurityRoute: SecurityRoute,
  SignInRoute: SignInRoute,
  EmailChangeVerifyRoute: EmailChangeVerifyRoute,
  PasswordResetRequestRoute: PasswordResetRequestRoute,
  SignInTotpRoute: SignInTotpRoute,
  SignInVerifyRoute: SignInVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
